import React from 'react'
import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';

function curriculum() {
  const tabs = [
    { title: 'Art', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Art Curriculum 2020-21</h1>
    </div>

    <div className='syllubus-data'>
    <Link  to="../pdf/curriculum/Art/PYP Visual Art Curriculum 20-21.pdf"
    target="_blank"
    rel="noopener noreferrer">
      <div className='syllubs-list'>
      PYP Visual Art      
      </div>
      </Link>

        <Link  to="../pdf/curriculum/Art/PYP Music Curriculum 2020-21.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
      <div className='syllubs-list'>
      PYP Music
      </div>
      </Link>
      <Link  to="../pdf/curriculum/Art/PYP Dance Curriculum 2020-21.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
      <div className='syllubs-list'>
    PYP Dance
      </div>
      </Link>
    </div>
    </div> },
    { title: 'Language', content: () => <div>

<div className='cam-lower-sec'>
    <h1 className='title'>Language Curriculum 2020-21</h1>
    </div>

    <div className='syllubus-data'>
    <Link  to="../pdf/curriculum/Language/EY Curriculum Language.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
    <div className='syllubs-list'>
      EY Curriculum Language
      </div>
      </Link>
      <Link  to="../pdf/curriculum/Language/PYP Curriculum Language.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
      <div className='syllubs-list'>
    PYP Curriculum Language
      </div>
    </Link>
    </div>

    </div> },
    { title: 'Mathematics', content: () => <div>

<div className='cam-lower-sec'>
    <h1 className='title'>Mathematics Curriculum 2020-21</h1>
    </div>

    <div className='syllubus-data'>
    <Link  to="../pdf/curriculum/Mathematics/EY Mathematics Curriculum 2020-21.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
    <div className='syllubs-list'>
      EY Curriculum Language
      </div>
      </Link>
      <Link  to="../pdf/curriculum/Mathematics/PYP Mathematics Curriculum 2020-21.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
      <div className='syllubs-list'>
      PYP Curriculum Language
      </div>
      </Link>
    </div>

    </div> },
  
  { title: 'PSPE', content: () => <div>

<div className='cam-lower-sec'>
    <h1 className='title'>PSPE Curriculum 2020-21</h1>
    </div>

    <div className='syllubus-data'>
    <Link  to="../pdf/curriculum/PSPE/EY PSPE Curriculum 2020.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
      <div className='syllubs-list'>
      EY Curriculum
      </div>
      </Link>
      <Link  to="../pdf/curriculum/PSPE/PYP PSPE Curriculum 2020-21.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
      <div className='syllubs-list'>
      PYP Curriculum
      </div>
      </Link>
    </div>

    </div> },

    { title: 'Science', content: () => <div>

<div className='cam-lower-sec'>
    <h1 className='title'>Science Curriculum 2020-21</h1>
    </div>

    <div className='syllubus-data'>
    <Link  to="../pdf/curriculum/Science/EY Science Curriculum 2020-21.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
      <div className='syllubs-list'>
      EY Curriculum
      </div>
      </Link>
      <Link  to="../pdf/curriculum/Science/PYP Science Curriculum 2020-21.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
      <div className='syllubs-list'>
      PYP Curriculum
      </div>
      </Link>
    </div>

    </div> },
    { title: 'Social Studies', content: () => <div>

<div className='cam-lower-sec'>
    <h1 className='title'>Social Studies Curriculum 2020-21</h1>
    </div>

    <div className='syllubus-data'>
    <Link  to="../pdf/curriculum/SST/EY Curriculum SSt 2020-21.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
      <div className='syllubs-list'>
      EY Curriculum
      </div>
      </Link>
      <Link  to="../pdf/curriculum/SST/PYP Curriculum SSt 2020-21.pdf"
    target="_blank"
    rel="noopener noreferrer"> 
      <div className='syllubs-list'>
      PYP Curriculum
      </div>
      </Link>
    </div>

    </div> },
  ];
  
  return (
    <div>
       <div className='ibdp-hero-sec'>
        <img src='img/Screenshot_29.webp'/>
      </div>
      <div className='ib-syllabus'>
        {/* <Igcsedata/> */}
        <HorizontalTabs tabs={tabs} />
      </div>
    </div>
  )
}

export default curriculum
